import React from "react"
import { TitleWithAbsoluteHint } from "swiipe.portal.shared"
import MerchantDashboardCellTitle from "../MerchantDashboardCellTitle"
import "./MerchantDashboardTileHeader.scss"

interface IMerchantDashboardTileHeaderProps {
    title: string
    icon?: string
    subtitle: string
    hintIconText?: string
    value?: number
    compareValue?: number
    diffValuePoints?: boolean
    invertPercentColors?: boolean
    isDisabled?: boolean
}

const MerchantDashboardTileHeader = ({
    title,
    icon,
    subtitle,
    hintIconText,
    value,
    compareValue,
    diffValuePoints,
    invertPercentColors,
    isDisabled,
}: IMerchantDashboardTileHeaderProps) => {
    return (
        <div className="merchant-dashboard-cell-container__header">
            <MerchantDashboardCellTitle
                title={title}
                icon={icon}
                subtitle={subtitle}
                value={value}
                compareValue={compareValue}
                diffValuePoints={diffValuePoints}
                invertPercentColors={invertPercentColors}
                isDisabled={isDisabled}
            />
            {hintIconText && (
                <div className="merchant-dashboard-header-info-icon">
                    <TitleWithAbsoluteHint
                        className="merchant-dashboard-header-info-icon__info"
                        titleLight
                        hintText={hintIconText}
                        iconLightGray
                        hintBoxWhite
                        hintAppearanceBottom
                        hintIconRight
                    />
                </div>
            )}
        </div>
    )
}

export default MerchantDashboardTileHeader
